import React, { useState, useContext } from 'react';
import axios from 'axios'
import { useEffect } from 'react';
import AuthContext from '../shop/Contexts/AuthContext'
import CartContext from '../shop/Contexts/CartContext'
import settings from '../../settings.json'
import CartTableDetail from './CartTableDetail';
import Collapse from "@kunukn/react-collapse";
import countries from './utils/countries.json'
import TitoloPagine from './TitoloPagine';
import Address from './Address';
import TableStepsOrder from './details/TableStepsOrder';
import Payment from './details/Payment';
import OrderResume from './details/OrderResume';
import { SpinnerOrder,SpinnerInsidePage } from '../MainComponents/Spinner';

let schema = {ordinato:true,data_ordinato:"1990-01-01",paid:false, payment_timestamp:null,shipped:false, shipping_timestamp:null,status:null}
let initStateAccordation = {isOpen0: false,isOpen1: false,isOpen2: false,isOpen3: false,}

function Order(props) {
    const [selectedShippingCost, setShippingCost] = useState(null)
    const [order, setOrder] = useState(undefined)
    const contextAuth = useContext(AuthContext)
    const contextCart = useContext(CartContext)
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [listOfAddress, setListOfAddress] = useState(null)
    const [listofShippingCost, setListofShippingCost] = useState(null)
    const [note, setNote] = useState(null)
    const [loading, setLoading] = useState(true)
    const [loadingPay, setloadingPay] = useState(false)
    const [optionPayment, setOptionPayment] = useState(null)
    const header = { 'headers': { 'Authorization': 'Token '+contextAuth.AuthState.token }}
    const [accordationState, setAccordationState] = useState(initStateAccordation)
    
    function getNameCountry(state_code){
        let list_of_country = countries.filter((country)=>{
            return country.code===state_code
        })
        if(list_of_country.length > 0){
            return list_of_country[0].name
        }
        return ""
    }

    function setAddress(address){
        setLoading(true)
        setSelectedAddress(address)
        axios.get(settings.url_api+'/api/shipping-cost/'+address.state+'/',header).then((res)=>{
            setListofShippingCost(res.data)
            setLoading(false)
        })
    }
    function goToNextAccordation(number){
        switch (number) {
            case 0:
                setAccordationState({isOpen0: true,isOpen1: false,isOpen2: false,isOpen3: false,})
                break;
            case 1:
                setAccordationState({isOpen0: false,isOpen1: true,isOpen2: false,isOpen3: false,})
                break;
            case 2:
                setAccordationState({isOpen0: false,isOpen1: false,isOpen2: true,isOpen3: false,})
                break;
            case 3:
                setAccordationState({isOpen0: false,isOpen1: false,isOpen2: false,isOpen3: true,})
                break;
            default:
                break;
        }
    }

    function saveOrder(transaction_id,order_status){
        //Salvataggio dell'ordine pagato, 
        //cancellazione dell'cart oramai completato con tutte le informazioni in un json, per riprodurre solo la visualizzazione
        setloadingPay(true)
        let data = {
            type:"confirmed",
            order_status:order_status,
            order_id:order.order_id,
            type_payment:optionPayment,
            billing_address:null,
            shipping_address:selectedAddress,
            shipping_cost:selectedShippingCost,
            isGift:false,
            note:note,
            transaction_id:transaction_id,
            cart:order.cart
        }
        axios.put(settings.url_api+'/api/orders/'+props.match.params.order_id+'/',data,header).then((res)=>{
            setOrder(res.data)
            contextCart.CartDispatch({type:"UPDATE_ORDER",payload:res.data})
        })

    }
    useEffect(() => {
        setLoading(true)
        //TODO: probabilmente non serve perchè già all'interno del contesto
        axios.get(settings.url_api+'/api/orders/'+props.match.params.order_id+'/',header).then((res)=>{
            setOrder(res.data)
            let resdata = res.data;
            // schema.status = resdata.status
            // if (resdata.status === "shipped" || resdata.status === "refunded"){
            //     schema.shipped = true
            //     schema.payment_timestamp = resdata.shipping_timestamp.split("T")[0]

            //     schema.paid = true
            //     schema.payment_timestamp = resdata.payment_timestamp.split("T")[0]

            //     schema.ordinato = true
            //     schema.data_ordinato = resdata.timestamp.split("T")[0]
            // }
            // if(resdata.status === "paid"){
            //     schema.paid = true
            //     schema.payment_timestamp = resdata.payment_timestamp.split("T")[0]

            //     schema.ordinato = true
            //     schema.data_ordinato = resdata.timestamp.split("T")[0]
            // }
            // if(resdata.status === "created"){
            //     schema.ordinato = true
            //     schema.data_ordinato = resdata.timestamp.split("T")[0]
            // }
            // setSchemaBar(schema)
            return resdata
        }).then((ord)=>{
            if(ord && ord.status === "created"){
                axios.get(settings.url_api+"/api/address/",header).then((res)=>{
                    setListOfAddress(res.data.results)
                    setAccordationState({isOpen1: true,isOpen2: false,isOpen3: false,})
                    setLoading(false)
                })
            }
        })
    }, [])
    
    return (
        <>
        {order && order.status==="created" ? 
        <div className="row" style={{padding:"0 5px"}}>
            <div className="itemsCart col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className={"accordation row"} style={{border:"1px solid black"}} onClick={(e)=>goToNextAccordation(0)}>
                    <div className="col-10">CARELLO{/*  ({selectedAddress ? "ok":"not ok"}) */} </div>
                    <div className="col-2" style={{textAlign:"right"}}><i className={accordationState.isOpen0 ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i></div>
                </div>
                <Collapse
                    isOpen={accordationState.isOpen0}
                    className={
                    "app__collapse app__collapse--gradient collapse-css-transition " +
                    (accordationState.isOpen0 ? "app__collapse--active" : "")
                    } >
                    <div>
                        <CartTableDetail cart={order.cart} showButton={false} showTotal={true}></CartTableDetail>
                    </div>
                </Collapse>
                <div className={"accordation row"} style={{border:"1px solid black"}} onClick={(e)=>goToNextAccordation(1)}>
                    <div className="col-10">INDIRIZZO{/*  ({selectedAddress ? "ok":"not ok"}) */} </div>
                    <div className="col-2" style={{textAlign:"right"}}><i className={accordationState.isOpen1 ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i></div>
                </div>
                <Collapse
                    isOpen={accordationState.isOpen1}
                    className={
                    "app__collapse app__collapse--gradient collapse-css-transition " +
                    (accordationState.isOpen1 ? "app__collapse--active" : "")
                    } >
                    {loading && !selectedAddress ? <SpinnerOrder /> : 
                        <div style={{padding:"15px"}}>
                            {listOfAddress && listOfAddress.map((addr,i)=>{
                                return(
                                    <div key={i} style={{textAlign:"left"}}>
                                        <label>
                                            <input type="radio" value={addr} checked={selectedAddress===addr} onChange={(e)=>setAddress(addr)}/>
                                            {"  "+ addr.name + " " + addr.lastname} <span style={{fontSize:"14px",fontWeight:"bold"}}>({addr.address}, {addr.city}, {addr.zipcode} - {getNameCountry(addr.state)})</span>
                                        </label>
                                        <hr/>
                                    </div>
                                )
                            })}
                            <div>
                                <button disabled={!selectedAddress} onClick={() => goToNextAccordation(2)} className="btn btn-dark bottone-avanti">
                                    AVANTI
                                </button>
                            </div>
                        </div>
                    }
                </Collapse>
                <div className={"accordation row"} style={{border:"1px solid black"}} onClick={(e)=>goToNextAccordation(2)}>
                    <div className="col-10">SPEDIZIONE {/*  ({selectedAddress ? "ok":"not ok"}) */} </div>
                    <div className="col-2" style={{textAlign:"right"}}><i className={accordationState.isOpen2 ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i></div>
                </div>
                <Collapse
                    isOpen={accordationState.isOpen2}
                    className={
                    "app__collapse app__collapse--gradient collapse-css-transition " +
                    (accordationState.isOpen2 ? "app__collapse--active" : "")
                    }
                >
                    {loading ? <SpinnerOrder /> : 
                        <div style={{padding:"15px"}}>
                            {listofShippingCost && listofShippingCost.map((ship,i)=>{
                                return(
                                    <div key={i} style={{textAlign:"left"}}>
                                        <label>
                                            <input type="radio" value={ship} checked={selectedShippingCost===ship} onChange={(e)=>setShippingCost(ship)}/>    
                                            <b>{ship.carrier}</b>{ship.name ? ship.name : null} : {Number(ship.shipping_price).toFixed(2)} €
                                            {ship.insurance_price > 0 ? <div>insurrance: + {Number(ship.insurance_price).toFixed(2)}€</div>:null}    
                                        </label>
                                        <hr/>
                                    </div>
                                )
                            })}
                            <div>
                                <button disabled={!selectedShippingCost} onClick={() => goToNextAccordation(3)} className="btn btn-dark bottone-avanti">
                                    AVANTI
                                </button>
                            </div>
                        </div>}
                </Collapse>
                <div className={"accordation row"} style={{border:"1px solid black"}} onClick={(e)=>goToNextAccordation(3)}>
                    <div className="col-10">PAGAMENTO {/*  ({selectedAddress ? "ok":"not ok"}) */} </div>
                    <div className="col-2" style={{textAlign:"right"}}><i className={accordationState.isOpen3 ? "chevron-up-active fa fa-chevron-up" : "chevron-up fa fa-chevron-up" }></i></div>
                </div>
                <Collapse
                    isOpen={accordationState.isOpen3}
                    className={
                    "app__collapse app__collapse--gradient collapse-css-transition " +
                    (accordationState.isOpen3 ? "app__collapse--active" : "")
                    }>  
                    {loading ? <SpinnerOrder /> : 
                        <div style={{textAlign:"left"}}>
                            <div>
                                <div className="radio">
                                <label>
                                    <input type="radio" value="paypal" checked={optionPayment === "paypal" ? true : false}  onChange={()=>{setOptionPayment("paypal")}} />
                                    Paypal
                                </label>
                                </div>
                                <div className="radio">
                                <label>
                                    <input type="radio" value="wire_transfer" checked={optionPayment === "wire_transfer" ? true : false} onChange={()=>{setOptionPayment("wire_transfer")}} />
                                    Bonifico
                                </label>
                                </div>
                                {!loadingPay ? 
                                    optionPayment ? 
                                        <div style={{textAlign:"center"}}>
                                            {optionPayment === "paypal" ? 
                                                <Payment order_id={order.order_id} shippingPrice={(Number(selectedShippingCost.insurance_price)+Number(selectedShippingCost.shipping_price)) .toFixed(2)} saveOrder={saveOrder}></Payment>
                                            :null}
                                            {optionPayment !== "paypal" ? 
                                                <button onClick={(e)=>{saveOrder(null)}}>Prosegui</button>
                                            :null}
                                        </div>
                                    :null
                                :<SpinnerOrder />}
                                {/* <Payment></Payment> */}
                            </div>
                            {order.note ? 
                            <div style={{border:"1px solid black", margin:"5px", padding:"5px"}}>
                                <div><b>Note:</b></div>
                                <div dangerouslySetInnerHTML={{ __html: order.note}}/>
                            </div> : null}
                        </div>
                    }
                </Collapse>
            </div>
            <div className="resumeCart col-lg-4 col-md-4 col-sm-12 col-xs-12" style={{textAlign:"left",margin:"0",padding:"0"}}>
                <div>
                    <OrderResume subtotal = {order.subtotal} tax_total={order.tax_total} selectedShippingCost={selectedShippingCost}></OrderResume>
                </div>
            </div>
        </div>
        : 
        order ?
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12" style={{textAlign:"left"}}>
                <TitoloPagine title={"DETTAGLIO ORDINE"}></TitoloPagine>
                <div className="order-code">
                    <b>ORDINE</b> - {order.order_id}
                    {order.isGift ? 
                        <div>
                            <i className="fa fa-gift"></i>  <small>L'ordine è contrassegnato come regalo</small>
                        </div>
                    :null}
                </div>

                <div className="order-steps">
                    <TableStepsOrder order={order}></TableStepsOrder>
                </div>
                <div className="order-currier">
                    <div className="row">
                        <div className="col-6 order-currier-label">METODO DI PAGAMENTO</div>
                        <div className="col-6 order-currier-item">{order.selected_payment}</div>
                    </div>
                    {order.payment_transaction_id ?
                        <div className="row">
                            <div className="col-6 order-currier-label">RIF. PAGAMENTO</div>
                            <div className="col-6 order-currier-item">{order.payment_transaction_id}</div>
                        </div>
                    :null}
                    <div className="row">
                        <div className="col-6 order-currier-label">CORRIERE</div>
                        <div className="col-6 order-currier-item"> {order.selected_shipment.carrier}</div>
                    </div>
                    {order.selected_shipment.carrier ? 
                            <div className="row">
                            <div className="col-6 order-currier-label">CODICE TRACCIABILITA'</div>
                            <div className="col-6 order-currier-item">{order.shipping_code ? order.shipping_code : <small>non ancora disponibile</small>}</div>
                        </div>
                    :null}

                    {order.selected_address ? 
                        <div className="row">
                            <div className="col-12 order-currier-label">INDIRIZZO</div>
                            <div className="col-12 col-8 order-currier-item">
                                <Address address={order.selected_address} showButton={false}></Address>
                                {order.billing_address ? <Address address={order.billing_address} showButton={false}></Address> : null}
                            </div>
                        </div>
                    :null}
                </div>
                
                <div className="carrello" style={{marginTop: "15px"}}>  
                <div className="order-currier-label">PRODOTTI</div>
                    <CartTableDetail cart={order.cart} showButton={false} showTotal={true}></CartTableDetail>
                </div>
            </div>
        :<SpinnerInsidePage />}
        </>
    );
}    

export default Order;